<template>
	<div class="p-3 IW">
		<div class=" ">


			<img v-if="!debug" alt="mem2" src="@/assets/others/mem2.jpg" style="max-width: 100%;">
			<template v-else>

				<div>
					<heizwert_-brennwert_converter/>
				</div>
				<div>
					<ReviewCarousel/>
					<ReviewCarousel has_trusted_shops_description/>
				</div>
				<div>
					<Quiz_VA_oder_BA/>
				</div>
				<div>
					<button_rueckruf/>
				</div>
				<div>
					<ReviewPartial :design="1"/>
				</div>
				<div>
					<ReviewPartial :design="2"/>
				</div>
				<div>
					<ReviewPartial :design="3"/>
				</div>
				<div>
					<ReviewPartial :design="4"/>
				</div>
				<!--				<div>
									<b>Check ReviewComponent</b>
									0.5:
									<rate-component :value="0.5" disabled/>
									1:
									<rate-component :value="1" disabled/>
									1.5:
									<rate-component :value="1.5" disabled/>
									2:
									<rate-component :value="2" disabled/>
									2.4:
									<rate-component :value="2.4" disabled/>
									2.6:
									<rate-component :value="2.6" disabled/>
									3:
									<rate-component :value="3" disabled/>
									4:
									<rate-component :value="4" disabled/>
									4.5:
									<rate-component :value="4.5" disabled/>
									5:
									<rate-component :value="5" disabled/>
								</div>-->
				<Foerderrechner_fuer_Einzelmassnahmen/>
				<Foerderrechner_fuer_Heizungstausch/>
				<ReviewBox/>
				<Heizkostenrechner_fuer_Bestandsgebaeude/>
				<ReviewsIndex/>
			</template>

		</div>
	</div>
</template>

<script>
export default {
	name: 'ImmobilienwerkerComponents',
	data() {
		return {};
	},
	computed: {
		debug() {
			return process.env.NODE_ENV !== 'production'
		},
	},
	components: {},
}
</script>
